import React from 'react';
import { Link } from 'gatsby';
import methodologyIconMobile from '../../images/methodology-m.svg';
import methodologyIconDesktop from '../../images/methodology-d.svg';
export const MethodologySection = () => (
	<section className="methodology">
		<div className="container section-wrapper">
			<h2 className="section-title">Redefining Global Citizenship </h2>
			<div className="section-content">
				<p
					className="section-text"
					data-sal="slide-up"
					data-sal-delay={100 + 0 * 150}
					data-sal-duration="350"
					data-sal-easing="ease"
				>
					While most indexes exclusively look at a passport’s travel
					privileges, that doesn’t tell the full story. We created a
					new methodology to determine a country’s allure for
					relocation, investment, or dual citizenship purposes. The
					result? Individuals can easily use our ranking system to
					discover a passport’s strength with three standalone
					indexes: Enhanced Global Mobility Index, Investment Index,
					and Quality of Life Index
				</p>
				<img
					src={methodologyIconMobile}
					alt="Methodology illustration"
					className="methodology__image mobile-only"
					data-sal="slide-up"
					data-sal-delay={100 + 1 * 150}
					data-sal-duration="350"
					data-sal-easing="ease"
				/>
				<img
					src={methodologyIconDesktop}
					alt="Methodology illustration"
					className="methodology__image desktop-only"
					data-sal="slide-up"
					data-sal-delay={100 + 1 * 150}
					data-sal-duration="350"
					data-sal-easing="ease"
				/>
				<div
					data-sal="slide-up"
					data-sal-delay={450}
					data-sal-duration="350"
					data-sal-easing="ease"
				>
					<Link to="/methodology/" className="btn btn__secondary">
						READ THE METHODOLOGY
					</Link>
				</div>
			</div>
		</div>
	</section>
);
